import React, { useState } from "react";
import {
  Button,
  TextField,  
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useAddBlackListNumberMutation } from "../../store/services/blacklistApi";
import { toast } from "react-toastify";

const AddToBlackList = () => {
  const [addBlackListNumber] = useAddBlackListNumberMutation();
  const [phoneNumbers, setPhoneNumbers] = useState("");
  const [loading, setLoading] = useState(false);

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!phoneNumbers.trim()) {
    toast.error("Please enter phone numbers.");
    return;
  }

  setLoading(true);

  try {
    const phoneNumbersArray = phoneNumbers
      .replace(/\n/g, ",")
      .split(",")
      .map((num) => num.trim())
      .filter((num) => num !== "");

    // 🔴 Validate: only digits allowed
    const invalidNumbers = phoneNumbersArray.filter(
      (num) => !/^\d+$/.test(num)
    );

    if (invalidNumbers.length > 0) {
      toast.error("Only numeric phone numbers are allowed.");
      setLoading(false);
      return;
    }

    // 🔴 Optional: length validation (example: 10–15 digits)
    const invalidLength = phoneNumbersArray.filter(
      (num) => num.length < 10 || num.length > 15
    );

    if (invalidLength.length > 0) {
      toast.error("Phone numbers must be between 10 and 15 digits.");
      setLoading(false);
      return;
    }

    const response = await addBlackListNumber({
      phone_numbers: phoneNumbersArray,
    }).unwrap();

    if (response.status) {
      toast.success("Phone numbers successfully added to the blacklist.");
      setPhoneNumbers("");
    } else {
      toast.error(response.message || "Error adding phone numbers.");
    }
  } catch (err) {
    toast.error(err?.data?.message || "Error adding phone numbers.");
  } finally {
    setLoading(false);
  }
};


  return (
   <Box
  sx={{
    p: 2,
    bgcolor: "white",
    boxShadow: 3,
    borderRadius: 2,
    width: 400,
    maxWidth: "100%",
  }}
>
  <Typography
    variant="h6"
    sx={{
      mb: 2,
      fontSize: "0.75rem",
      fontWeight: 600,
    }}
  >
    Add Numbers to Blacklist
  </Typography>

  <form onSubmit={handleSubmit}>
    <TextField
      label="Phone Numbers"
      multiline
      rows={5}
      fullWidth
      value={phoneNumbers}
      onChange={(e) => {
  const value = e.target.value.replace(/[^\d,\n]/g, "");
  setPhoneNumbers(value);
}}
      variant="outlined"
      helperText="Enter phone numbers, one per line or comma separated"
      size="small"
      sx={{
        mb: 2,
        "& .MuiInputBase-input": {
          fontSize: "0.75rem",
        },
        "& .MuiInputLabel-root": {
          fontSize: "0.75rem",
        },
        "& .MuiFormHelperText-root": {
          fontSize: "0.65rem",
        },
      }}
    />

    <Button
      type="submit"
      variant="contained"
      color="primary"
      disabled={loading}
      size="small"
      fullWidth
      sx={{ fontSize: "0.7rem", textTransform: "none" }}
    >
      {loading ? <CircularProgress size={20} color="inherit" /> : "Add to Blacklist"}
    </Button>
  </form>
</Box>

  );
};

export default AddToBlackList;